import { Box, IconButton, Stack, styled } from "@mui/material";
import { CircleChatIcon } from "Assets/icons";
import { XsText } from "Components";
import { BaseSupplierInfors } from "Components/infos/BaseSupplierInfors";
import useChat from "hooks/useChat";
import { Fragment } from "react";
import { InquiryCompanyType } from "types/inquiry";

type Props = {
  farm_data: InquiryCompanyType;
};

const InquiryCompany = ({ farm_data }: Props) => {
  const { attr = [], identity } = farm_data;
  const { onOpenConversationWithIdentity } = useChat();

  return (
    <StyledBox>
      <Stack spacing={1} direction="row" alignItems="center">
        <BaseSupplierInfors company={farm_data} />

        <IconButton onClick={() => onOpenConversationWithIdentity(identity)}>
          <CircleChatIcon />
        </IconButton>
      </Stack>

      {attr.length > 0 && (
        <XsText className="attributes cutoff-text twoline" mt={2}>
          {attr.map((data) => (
            <Fragment key={data.key}>
              {data.key}: <span>{data.value}</span>
            </Fragment>
          ))}
        </XsText>
      )}
    </StyledBox>
  );
};

const StyledBox = styled(Box)({
  ".avatar": {
    height: 59,
    width: 59,
    objectFit: "cover",
  },
  ".verify-plan": {
    img: {
      width: 16,
      height: 16,
    },
  },
});

export default InquiryCompany;
